module.exports = __webpack_public_path__ + "static/media/stripe-create-account_5.694b7378.png";